//@ts-nocheck

import { ConfigProvider, DatePicker, TimePicker } from 'antd';
import './stylesComponent.scss';
import cn from 'classnames';
import Label from './Label';
import HelperText from './HelperText';
import 'dayjs/locale/ar';

import { inputBaseClasses } from './Input';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  id: string;
  status?: 'error' | 'success';
  disabled?: boolean;
  helperText?: string;
  label?: string | React.ReactNode;
  required?: boolean;
  optional?: boolean;
  labelHelperText?: string;
} & Omit<React.ComponentProps<typeof DatePicker>, 'status'>;

const CustomTimePicker = forwardRef<HTMLInputElement, Props>(
  (
    {
      status,
      disabled,
      id,
      helperText,
      label,
      optional,
      required,
      labelHelperText,
      fromHour,
      toHour,
      fromMinute,
      toMinute,
      isDisableHours,
      isDisableMins,
      ...props
    }: Props,
    ref
  ) => {
    const { t } = useTranslation();

    // Disable all hours outside of allowed range
    const disabledHours = () => {
      const disabled: number[] = [];
      for (let i = 0; i < 24; i++) {
        if (i < fromHour || i > toHour) {
          disabled.push(i);
        }
      }
      return disabled;
    };

    // Disable minutes outside of range at edge hours
    const disabledMinutes = (selectedHour: number) => {
      if (selectedHour === fromHour) {
        return Array.from({ length: 60 }, (_, i) => i).filter(
          (i) => i < fromMinute
        );
      }
      if (selectedHour === toHour) {
        return Array.from({ length: 60 }, (_, i) => i).filter(
          (i) => i > toMinute
        );
      }
      return [];
    };

    return (
      <div className="our-date-picker flex flex-col">
        {label && (
          <Label
            optional={optional}
            labelHelperText={labelHelperText}
            required={required}
            htmlFor={id}
            text={label}
          />
        )}
        <ConfigProvider>
          <TimePicker
            use12Hours
            format="h:mm a"
            {...props}
            className={cn(inputBaseClasses, {
              '!border-red-500  ': status === 'error',
              '!border-green-500 ': status === 'success',
              'border-0 dark:border dark:!border-dark-text-placeholder !bg-light-button-label-primary dark:!bg-transparent':
                disabled,
            })}
            size="large"
            disabled={disabled}
            ref={ref}
            showNow={false}
            disabledHours={isDisableHours ? disabledHours : null}
            disabledMinutes={isDisableMins ? disabledMinutes : null}
          />
        </ConfigProvider>
        {helperText && (
          <HelperText text={helperText} disabled={disabled} status={status} />
        )}
      </div>
    );
  }
);

CustomTimePicker.displayName = 'CustomTimePicker';

export default CustomTimePicker;
